import { SparkIcon } from '../SparkIcon';
import './InputChevron.css';

/** Chevron indicator inside select-style inputs. Toggles between up and down based on `open`. */
export type InputChevronProps = {
  open?: boolean;
  disabled?: boolean;
  className?: string;
};

/** Figma Input Chevron (`682:81164`) — 18×18 hit area, 16px icon, toggles up/down. */
export function InputChevron({ open = false, disabled = false, className = '' }: InputChevronProps) {
  const classes = [
    'spark-input-chevron',
    open ? 'spark-input-chevron-open' : 'spark-input-chevron-closed',
    disabled ? 'spark-input-chevron-disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} aria-hidden="true">
      <SparkIcon slug={open ? 'chevron-up' : 'chevron-down'} size="small" />
    </span>
  );
}
